jQuery($ => {
    class ProductsFeed {
      constructor(element) {
        this._        = element;
        this._element = $(element);
        this._form    = this._element.find('.o-products-feed__filters-form');
        this._inputs  = this._form.find('input, select');

        this._useAjax = this._element.hasClass('o-products-feed--has-ajax');
        this._ajaxRunning = 0;
  
        this.init();
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      init() {
        this.setupHandlers();
        this._element.trigger( 'init', this );
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Submit
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleSubmit() {
        // Get all fields from form
        let formData = this._form.serialize();

        formData += '&action=load_filtered_products';
        formData += `&url=${JSON.stringify(window.location.href.replace(window.location.search, ''))}`;

        this._element.addClass('o-products-feed--loading');

        // Push current feed html and url to history
        window.history.pushState(
          {
            feed: this._element.html(),
          },
          {},
          window.location.href
        );

        $.ajax({
          type: 'POST',
          url: AJAX.url,
          data: formData,
          beforeSend: function() {
            this._ajaxRunning++;
          },
          success: function(result) {
            if (result.data.feed) {
              this._element.html(result.data.feed);              
            }

            if (result.data.url) {
              window.history.pushState(
                {
                  feed: result.data.feed,
                },
                {},
                result.data.url
              );
            }
          },
          error: function(error) {
            console.error(error);
          },
          complete: function() {
            this._ajaxRunning--;
            this._element.removeClass('o-products-feed--loading');
          }
        })
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      setupHandlers() {
        this._inputs.on('change', () => {
          this._form.submit();
        });

        this._form.on('submit', (e) => {
          if (this._useAjax) {
            e.preventDefault();
            this.handleSubmit();
          }
        });
      }
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $.fn.products_feed = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].products_feed = new ProductsFeed(_[i], opt);
        else
          ret = _[i].products_feed[opt].apply(_[i].products_feed, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    // $('.o-products-feed').products_feed();

    $.fn.getPage = function () {
      var page = 1;

      if ($(this).hasClass('m-pagination__page')) {
        page = parseInt($(this).text());
      } else {
        const currentPage = parseInt($('.m-pagination__page--active').text());
        if ($(this).hasClass('m-pagination__direction--right')) {
          page = currentPage + 1;
        } else if ($(this).hasClass('m-pagination__direction--left')) {
          page = currentPage - 1;
        }
      }
  
      return page;
    };

    function handleReset() {
      const form = $('.o-products-feed__filters-form');
      form[0].reset();
      // setTimeout(() => {        
        handleSubmit(0, true);
      // }, 100);
    }

    function handleSubmit(page, isReset) {
      const root = $('.o-products-feed');
      const form = $('.o-products-feed__filters-form');

      const pageInput = form.find('input[name="paged"]');
      if (pageInput[0] && page >= 1) {
        pageInput.val(page);
      }

      // Get all fields from form
      let formData = form.serialize();
      
      if (isReset) {
        formData = '';
        // Get page_size input value
        const pageSize = form.find('select[name="page_size"]');
        if (pageSize[0]) {
          formData += `page_size=${pageSize.val()}`;
        }
      }

      formData += '&action=load_filtered_products';
      formData += `&url=${window.location.href.replace(window.location.search, '')}`;      

      // Push current feed html and url to history
      window.history.pushState(
        {
          feed: root.html(),
        },
        {},
        window.location.href
      );

      root.addClass('o-products-feed--loading');

      $.ajax({
        type: 'POST',
        url: AJAX.url,
        data: formData,
        beforeSend: function() {
          AjaxRunning++;
        },
        success: function(result) {
          if (result.data.feed) {
            root.html(result.data.feed);

            // Make sure accordions and add-to-quote-buttons are re-initialized
            setTimeout(() => {
              root.find('.m-accordion').each(function() {
                $(this).accordion();
              });

              root.find('.m-add-to-quote-button').each(function() {
                $(this).add_to_quote_button();
              });
            }, 100);
          }

          if (result.data.url) {
            window.history.pushState(
              {
                feed: result.data.feed,
              },
              {},
              result.data.url
            );
          }

          if (page) {
            // If coming from pagination, scroll to top of feed
            const y = $('.o-products-feed__main')[0].getBoundingClientRect().top + window.scrollY + -180;
            window.scrollTo({ top: y, behavior: 'smooth' });
          }

          $(window).trigger('ajax');
        },
        error: function(error) {
          console.error(error);
        },
        complete: function() {
          AjaxRunning--;
          root.removeClass('o-products-feed--loading');
        }
      })
    }

    var AjaxRunning = 0;

    $(window).on('load ajax', function () {
      if ($('.o-products-feed__filters-form')[0]) {
        const form = $('.o-products-feed__filters-form');

        form.on('submit', function(e) {
          if (form.attr('data-ajax') == 'true') {
            e.preventDefault();
            handleSubmit();
          }
        });

        form.on('reset', function(e) {
          handleReset();
        });

        form.find('input, select').on('change', function() {
          form.submit();
        });
      }

      $('.o-products-feed .m-pagination__page').click(function (e) {
        e.preventDefault();
        var page = $(this).getPage();
        handleSubmit(page);
      });

      $('.o-products-feed .m-pagination__direction').click(function (e) {
        e.preventDefault();
        var page = $(this).getPage();
        handleSubmit(page);
      });
    });

    if ($('.o-products-feed')[0]) {
      $(window).on('popstate', function (e) {
        if (e.originalEvent.state !== null) {
          if (e.originalEvent.state.feed) {
            $('.o-products-feed').html(e.originalEvent.state.feed);

            // Make sure accordions, add-to-quote-buttons and pagination events are re-initialized
            setTimeout(() => {
              $('.o-products-feed').find('.m-accordion').each(function() {
                $(this).accordion();
              });

              $('.o-products-feed').find('.m-add-to-quote-button').each(function() {
                $(this).add_to_quote_button();
              });

              $('.o-products-feed .m-pagination__page').click(function (e) {
                e.preventDefault();
                var page = $(this).getPage();
                handleSubmit(page);
              });
        
              $('.o-products-feed .m-pagination__direction').click(function (e) {
                e.preventDefault();
                var page = $(this).getPage();
                handleSubmit(page);
              });

              if ($('.o-products-feed__filters-form')[0]) {
                const form = $('.o-products-feed__filters-form');
        
                form.on('submit', function(e) {
                  if (form.attr('data-ajax') == 'true') {
                    e.preventDefault();
                    handleSubmit();
                  }
                });
        
                form.find('input, select').on('change', function() {
                  form.submit();
                });
              }
            }, 100);
          }
        }
      });
    }
});